export default __webpack_public_path__ + "static/media/114_mobile.e112eb0f.jpg";